import { TeamInvite } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamInviteCreateReq, teamApi } from '../api';
import { TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface CreateTeamInviteParams {
  teamId: string;
  teamInviteCreateReq: TeamInviteCreateReq;
}

interface CreateTeamInviteResult {
  invite: TeamInvite;
  inviteUrl: string;
}

export const useCreateTeamInvite = () => {
  const queryClient = useQueryClient();

  const createTeamInviteMutation = useMutation({
    mutationFn: ({ teamId, teamInviteCreateReq }: CreateTeamInviteParams) => {
      return teamApi.createTeamInvite(teamId, teamInviteCreateReq).then(({ data }) => {
        return {
          invite: data.invite as TeamInvite,
          inviteUrl: data.inviteUrl as string,
        } as CreateTeamInviteResult;
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
    },
  });

  return {
    createTeamInvite: createTeamInviteMutation.mutateAsync,
    isCreatingTeamInvite: createTeamInviteMutation.isPending,
    ...createTeamInviteMutation,
  };
};
